//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  required as validateRequired,
  email as validateEmail,
  url as validateUrl,
  minValue as validateMinValue,
  maxValue as validateMaxValue,
} from 'vuelidate/lib/validators'

import formValidation from '~/mixins/formValidation'

export default {
  mixins: [formValidation],
  props: {
    id: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    icon: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
    autocomplete: {
      type: String,
      default: null,
    },
    inputmode: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      listeners: {
        input: (event) => this.onInput(event.target.value),
        blur: (event) => this.onInvalid(),
      },
    }
  },

  mounted() {
    this.$emit('invalid', {
      invalid: this.$v.$invalid,
      name: this.name,
    })
  },

  methods: {
    onInput(value) {
      this.$emit('input', value)
    },

    onInvalid() {
      // reset error
      this.error = null

      // set error
      if (this.required && !this.$v.value.required) {
        this.error = this.$translation('form.required')
      } else if (this.type === 'email' && !this.$v.value.email) {
        this.error = 'Please fill in this field a valid email address.'
      } else if (this.$v.$invalid) {
        this.error = 'Please fill in this field correctly.'
      }

      // set invalid
      this.invalid = this.$v.$invalid
      this.$emit('invalid', {
        invalid: this.invalid,
        error: this.error,
        name: this.name,
      })
    },
  },

  validations() {
    return {
      value: {
        required: this.required ? validateRequired : true,
        min: this.min ? validateMinValue(this.min) : true,
        max: this.max ? validateMaxValue(this.max) : true,
        email: this.type === 'email' ? validateEmail : true,
        url: this.type === 'url' ? validateUrl : true,
      },
    }
  },
}
